import { __assign, __extends } from "tslib";
import React from "react";
var SVG = /** @class */ (function (_super) {
    __extends(SVG, _super);
    function SVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVG.prototype.render = function () {
        return React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, this.props),
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("path", { fill: "#FFF", d: "M12.59 15.592l.032 1.7h-1.348l.033-1.645c-1.206-.122-1.89-.762-2.2-1.037l.917-1.283c.332.308 1.05.788 1.946.788.63 0 .94-.299.94-.695 0-.44-.354-.632-1.205-1.018l-.664-.3c-1.15-.505-1.625-1.188-1.625-2.068 0-1.187.885-2.217 2.034-2.426l-.044-1.645h1.349l-.033 1.644c1.061.177 1.558.845 1.648.966l-.963 1.192a2.04 2.04 0 0 0-1.437-.597c-.575 0-.874.311-.874.718 0 .45.41.7 1.106 1.019l.542.246c1.26.571 1.835 1.138 1.835 2.182 0 .989-.663 2.006-1.99 2.259" }),
                React.createElement("ellipse", { cx: "11.983", cy: "11.925", stroke: "#FFF", rx: "11.483", ry: "11.425" })));
    };
    return SVG;
}(React.Component));
export default SVG;
